import { APIRequest } from "@companion-core/shared/app/Interfaces/API";

export enum RequestDetailContent {
  detail = "detail",
  proposals = "proposals",
  recommendations = "recommendations",
}

export enum RequestDetailAction {
  modify = "modify",
  decline = "decline",
}

export interface RequestDetailProps {
  data: APIRequest;
  id: string;
  contentId?: string;
  detailContent?: RequestDetailContent;
  navigateToDetailContent: (to: RequestDetailContent) => void;
  navigateToDetailRecommendation: (proposalId: string, recommendationId: string) => void;
  navigateToEditor?: (action: RequestDetailAction) => void;
  goBack?: () => void;
}

export interface RequestDetailFooterProps {
  status: string;
  hasDigitalProposal: boolean;
  requestDetailContent: RequestDetailContent;
  navigateToEditor?: (action: RequestDetailAction) => void;
}

export interface RequestDetailsPageRouteProps {
  id?: string;
  content?: RequestDetailContent;
}
